<template>
  <div>
    <a-form :form="form" layout="vertical">
      <div class="row">
        <div class="every">
          <span>{{ $t('admin.headerFooter.footer.preview') }}</span>
          <div class="content">
            <div class="preview previewFooter" ref="previewFooter" :style="{ background: form.footerBackground || '#000', color: form.footerFont || '#fff'}" @mouseenter="hoverEnter" @mouseleave="mouseLeave">
              <div class="relevance">
                <div v-for="item of form.friend" :key="item.id">{{ item.name }}</div>
              </div>
              <div class="info" v-html="form.info" :style="{ color: form.footerFont || '#fff' }"></div>
              <div class="desc">
                <div>{{ $t('admin.headerFooter.footer.footerInfo.browserSupport') }}</div>
                <div>{{ $t('admin.headerFooter.footer.footerInfo.techSupport') }}</div>
                <div>{{ $t('admin.headerFooter.footer.footerInfo.icp') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="every" style="width: 100%">
          <span>{{ $t('admin.headerFooter.footer.friendlyLinks.title') }}</span>
          <div class="content friend">
            <a-table
              class="table"
              :columns="columns"
              :pagination="pagination"
              :data-source="form.friend">
              <template slot="operate" slot-scope="text, record, index">
                <div class="operate">
                  <span v-if="!record.isAdmin" @click="create(record, index)">{{ $t('admin.headerFooter.footer.friendlyLinks.actions.edit') }}</span>
                  <span v-if="!record.isAdmin" @click="deleteFriend(record.id)">{{ $t('admin.headerFooter.footer.friendlyLinks.actions.delete') }}</span>
                </div>
              </template>
            </a-table>
            <a-button @click="create(null)" :disabled="form.friend.length >= 20" class="create">{{ $t('admin.headerFooter.footer.friendlyLinks.actions.add') }}</a-button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="every" style="width: 100%">
          <span>{{ $t('admin.headerFooter.footer.footerInfo.title') }}</span>
          <div class="content infoEdit">
            <a-textarea class="textarea" v-model="form.info" :auto-size="{ minRows: 3, maxRows: 6 }" maxLength="150"></a-textarea>
            <div class="num">
              <span>{{ form.info.length }}</span>
              <span>/150</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="every" style="width: 40%">
          <span>{{ $t('admin.headerFooter.footer.background.label') }}</span>
          <div class="content">
            <a-radio-group class="radioGroup" v-model="footerBackgroundHas" @change="changeColor('footerBackground')">
              <a-radio :value="false">{{ $t('admin.headerFooter.footer.background.options.none') }}</a-radio>
              <a-radio :value="true">{{ $t('admin.headerFooter.footer.background.options.color') }}</a-radio>
            </a-radio-group>
            <div class="colorSelect" @click="colorSelect('footerBackground')" v-if="footerBackgroundHas">
              <div :style="{ background: form.footerBackground }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
            <div class="colorSelectPicker" v-show="showPicker" @click="showPicker = false">
              <div id="pickerFooter" @click.stop></div>
            </div>
          </div>
        </div>
        <div class="every" style="width: 26%">
          <span>{{ $t('admin.headerFooter.footer.fontColor.label') }}</span>
          <div class="content">
            <div class="colorSelect colorSelectBig" @click="colorSelect('footerFont')">
              <span @click.stop="resetColor('footerFont')">{{ $t('admin.headerFooter.footer.fontColor.reset') }}</span>
              <div :style="{ background: form.footerFont }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
          </div>
        </div>
        <div class="every" style="width: 26%">
          <span>{{ $t('admin.headerFooter.footer.navHoverColor.label') }}</span>
          <div class="content">
            <div class="colorSelect colorSelectBig" @click="colorSelect('footerSelectFont')">
              <span @click.stop="resetColor('footerSelectFont')">{{ $t('admin.headerFooter.footer.navHoverColor.reset') }}</span>
              <div :style="{ background: form.footerSelectFont }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </a-form>
    <a-modal :title="$t('admin.headerFooter.footer.friendlyLinks.modal.title')" :visible="showAddFriend" @ok="submitAddFriend" @cancel="showAddFriend = false">
      <a-form :form="formFriend">
        <a-form-item :label="$t('admin.headerFooter.footer.friendlyLinks.modal.name.label')">
          <a-input 
            allowClear 
            :maxLength="15" 
            v-decorator="['name', { rules: [{ required: true, message: $t('admin.headerFooter.footer.friendlyLinks.modal.name.required') }] }]" 
            :placeholder="$t('admin.headerFooter.footer.friendlyLinks.modal.name.placeholder')" 
          />
        </a-form-item>
        <a-form-item :label="$t('admin.headerFooter.footer.friendlyLinks.modal.url.label')">
          <a-input
            allowClear
            v-decorator="['url', { rules: [{ required: true, message: $t('admin.headerFooter.footer.friendlyLinks.modal.url.placeholder') }, { type: 'url', message: $t('admin.headerFooter.footer.friendlyLinks.modal.url.urlError') }] }]"
            :placeholder="$t('admin.headerFooter.footer.friendlyLinks.modal.url.placeholder')"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import iro from '@jaames/iro'

export default {
  name: 'HeaderFooter',
  data() {
    return {
      form: {
        info: '',
        desc: '推荐使用：谷歌(Google Chrome)浏览器、火狐(Firfox)浏览器\n技术支持：北京格如灵科技有限公司\n备案号:京ICP备16064072号-1',
        friend: [],
        footerBackground: '',
        footerFont: ''
      },
      formFriend: this.$form.createForm(this),
      footerBackgroundHas: false,
      showPicker: false,
      showAddFriend: false,
      columns: [
        {
          title: this.$t('admin.headerFooter.footer.friendlyLinks.columns.name'),
          dataIndex: 'name'
        },
        {
          title: this.$t('admin.headerFooter.footer.friendlyLinks.columns.url'),
          dataIndex: 'url'
        },
        {
          title: this.$t('admin.headerFooter.footer.friendlyLinks.columns.operations'),
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      pagination: {
        pageSize: 100
      },
      curEditIndex: -1
    }
  },
  watch: {
    'form.footerBackground': {
      handler(val) {
        console.log(val)
        this.footerBackgroundHas = !!val
      },
      immediate: true
    },
  },
  methods: {
    // Your methods here
    colorSelect(key) {
      this.colorKey = key
      this.showPicker = !this.showPicker
    },
    resetColor(key) {
      this.form[key] = ''
      this.$forceUpdate()
    },
    deleteFriend(id) {
      this.form.friend = this.form.friend.filter(item => item.id !== id)
    },
    create(data, index) {
      this.showAddFriend = true
      this.$nextTick(() => {
        if (data) {
          this.curEditIndex = index
          this.formFriend.setFieldsValue(data)
        } else {
          this.curEditIndex = -1
          this.formFriend.resetFields()
        }
      })
    },
    hoverEnter() {
      this.$refs.previewFooter.style.color = this.form.footerSelectFont || '#fff'
    },
    mouseLeave() {
      this.$refs.previewFooter.style.color = this.form.footerFont || '#fff'
    },
    submitAddFriend() {
      this.formFriend.validateFields((err, values) => {
        if (err) return
        if (this.curEditIndex > -1) {
          this.form.friend.splice(this.curEditIndex, 1, {
            id: this.form.friend[this.curEditIndex].id,
            ...this.formFriend.getFieldsValue()
          })
        } else {
          this.form.friend.push({
            id: new Date().getTime(),
            ...this.formFriend.getFieldsValue()
          })
        }
        this.showAddFriend = false
      })
    },
    changeColor(key) {
      this.form[key] = this[key + 'Has'] ? '#ffffff' : ''
    },
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    // Your mounted hook logic here
    this.boxPicker = new iro.ColorPicker('#pickerFooter', {
      width: 250,
      color: 'rgb(255, 0, 0)',
      borderWidth: 1,
      borderColor: '#fff',
      layout: [
        {
          component: iro.ui.Box
        },
        {
          component: iro.ui.Slider,
          options: {
            id: 'hue-slider',
            sliderType: 'hue'
          }
        }
      ]
    })
    this.boxPicker.on('color:change', color => {
      // 将当前颜色记录为十六进制字符串
      console.log(color.hexString)
      this.form[this.colorKey] = color.hexString
      this.$forceUpdate()
    })
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    .every {
      width: 100%;
      // display: flex;
      > span {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        display: flex;
        // width: 100px;
        padding-top: 6px;
      }
      .content {
        width: calc(100% - 100px);
        display: flex;
        margin-top: 15px;
        .radioGroup.ant-radio-group{
          .ant-radio-wrapper{
            padding: 0 5px;
          }
        }
        .preview {
          width: 100%;
          height: 75px;
          border: 9px solid #f3f4f5;
          background: #fff;
          border-radius: 4px;
          padding: 0 26px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          > img {
            height: 34px;
            background: #d8d8d8;
            border-radius: 8px;
            border: 1px solid #ebebeb;
          }
          .user {
            display: flex;
            align-items: center;
            img {
              width: 14px;
              margin-right: 3px;
            }
          }
        }
        .previewFooter{
          display: block;
          padding: 40px 0 0 0;
          height: auto;
          .relevance {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            > div{
              font-size: 14px;
              font-weight: 600;
              // color: #000000;
              line-height: 20px;
              margin-right: 20px;
              &::before{
                content: '|';
                margin-right: 20px;
                color: #919191;
              }
            }
            > div:nth-child(1)::before{
              content: '';
            }
          }
          .info{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 16px;
          }
          .desc{
            width: 100%;
            height: 28px;
            background: #F9F9F9;
            margin-top: 37px;
            display: flex;
            justify-content: center;
            align-items: center;
            > div{
              font-weight: 400;
              font-size: 12px;
              color: #949494;
              line-height: 12px;
              font-style: normal;
            }
          }
        }
        .table{
          width: 100%;
        }
        .colorSelect {
          width: 62px;
          height: 35px;
          background: #fcfcfc;
          border-radius: 6px;
          border: 1px solid #e8ecf0;
          padding-right: 20px;
          box-sizing: border-box;
          position: relative;
          // margin-left: 10px;
          overflow: hidden;
          > div {
            width: 100%;
            height: 100%;
            background: #fff;
            border-radius: 0 5px 5px 0;
          }
          img {
            position: absolute;
            top: 14px;
            right: 6px;
            width: 11px;
          }
        }
        .colorSelectBig {
          min-width: 106px;
          display: flex;
          align-items: center;
          > span{
            color: #fff;
            font-size: 12px;
            cursor: pointer;
            background-color: #AFAFAF;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            padding: 0 2px;
            line-height: 1.2;
            height: 100%;
          }
        }
        .colorSelectPicker {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
      }
      .friend{
        display: block;
        width: 100%;
        .create{
          margin-top: 10px;
        }
      }
      .infoEdit{
        position: relative;
        .textarea{
          padding-bottom: 30px;
        }
        .num{
          position: absolute;
          right: 8px;
          bottom: 8px;
        }
      }
    }
    .must {
      &::before {
        content: '*';
        color: #ff4d4f;
        margin-left: 5px;
        width: 8px;
      }
      > span {
        width: 92px;
      }
    }
  }
}
</style>
